// Units dictionary for various activities

export const ACTIVITY_UNITS = {
  "PRODUCTION": "Kbd",
  "REFINERY INTAKE": "Kbd",
  "REFINERY OUTPUT": "Kbd",
  "CONSUMPTION": "Kbd",
  "INVENTORY": "mmbbl",
  "DIRECT BURN": "Kbd"
};

export const UNITS_DICTIONARY = {
  "Kbd": {
    label: "Thousand Barrels per Day",
    shortLabel: "Kbd",
    factor: 1000,
    type: "volumeFlow",
    baseUnit: "bbl/day"
  },
  "mmbbl": {
    label: "Million Barrels",
    shortLabel: "mmbbl",
    factor: 1000000,
    type: "volume",
    baseUnit: "bbl"
  }
};

// export default UNITS_DICTIONARY;